import { useState, useEffect } from 'react';
import { PaperclipIcon, SendIcon } from './icons';

export type ButtonState = 'attach' | 'send';

interface MorphingButtonProps {
  state: ButtonState;
  onClick: () => void;
  disabled: boolean;
  className?: string;
}

export function MorphingButton({
  state,
  onClick,
  disabled,
  className = '',
}: MorphingButtonProps) {
  const [isMorphing, setIsMorphing] = useState(false);
  const [displayedState, setDisplayedState] = useState<ButtonState>(state);

  // Handle state changes with morphing animation
  useEffect(() => {
    if (state !== displayedState) {
      setIsMorphing(true);

      // Wait for morph-out animation (150ms)
      setTimeout(() => {
        setDisplayedState(state);

        // Wait for morph-in animation (150ms)
        setTimeout(() => {
          setIsMorphing(false);
        }, 150);
      }, 150);
    }
  }, [state, displayedState]);

  const isAttach = displayedState === 'attach';

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      title={isAttach ? 'Attach file' : 'Send message'}
      className={`
        absolute bottom-2 right-2 w-9 h-9 rounded-full
        flex items-center justify-center
        transition-all duration-300
        shadow-md hover:shadow-lg
        ${isAttach
          ? 'bg-gray-100 text-gray-600 hover:bg-gray-200 hover:text-gray-700'
          : 'bg-blue-500 text-white hover:bg-blue-600'
        }
        ${disabled ? 'opacity-50 cursor-not-allowed' : 'hover:scale-110 cursor-pointer'}
        ${className}
      `}
    >
      <div className={isMorphing ? 'morphing-out' : 'morphing-in'}>
        {isAttach ? (
          <PaperclipIcon size={18} />
        ) : (
          <SendIcon size={18} />
        )}
      </div>
    </button>
  );
}
